<template>
  <div class="images" ref="images">
    <h6>{{ title }} [{{ result_length }}]</h6>
    <br />
    <button
      @click="$refs.uploadImage.click()"
      class="btn btn-sm btn-success mb-4"
    >
      <span class="ti-plus"></span> Добавить изображения
    </button>
    <card v-if="base64 && base64.length">
      <h6>Новые изображения</h6>
      <br />
      <div :class="`upload ${uploading === true ? 'loading' : ''}`">
        <draggable
          v-if="base64 && base64.length"
          :tag="'ul'"
          v-model="base64"
          class="pimages mb-3"
        >
          <li v-for="(file, key) in base64" :key="key">
            <img :src="file['content']" alt="" />
            <button @click="removeItemBase64(key)">
              <span class="ti-close"></span>
            </button>
          </li>
        </draggable>

        <button
          v-if="uploading === false"
          @click="$refs.uploadImage.click()"
          class="btn btn-sm btn-info mr-3"
        >
          <span class="ti-plus"></span> Еще
        </button>

        <button
          v-if="uploading === false"
          @click="uploadCancel"
          class="btn btn-sm btn-warning"
        >
          Отмена
        </button>
      </div>
    </card>
    <input
      type="file"
      ref="uploadImage"
      @change="chooseImages"
      accept="image/*"
      :value="file_value"
      class="choose-file"
      v-bind:multiple="true"
    />
    <draggable
      :tag="'ul'"
      v-model="result"
      class="pimages"
      @change="positionItem"
    >
      <template v-for="(item, key) in result">
        <li v-if="item && item.id" :key="item.id">
          <img :src="item[url]" alt="" />
          <button @click="removeItem(item, key)">
            <span class="ti-close"></span>
          </button>
        </li>
      </template>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  data: () => ({
    base64: [],
    file_value: "",
    uploading: false,
  }),
  components: {
    draggable,
  },
  props: {
    url: {
      default: "file_medium",
    },
    value: {
      default: function () {
        return [];
      },
    },
    result: {
      default: function () {
        return [];
      },
    },
    title: {
      default: function () {
        return "";
      },
    },
    link: {
      default: function () {
        return "images";
      },
    },
  },

  methods: {
    modalClose() {},
    modalOpen() {},
    chooseImages() {
      try {
        let new_images = this.$refs.uploadImage.files;
        for (let i = 0; i < new_images.length; i++) {
          let file = new_images[i];
          const reader = new FileReader();
          reader.readAsDataURL(file);

          reader.addEventListener("load", () => {
            this.base64.push({
              file: file,
              content: reader.result,
            });
          });
        }
        this.$emit("input", this.base64);
      } catch (error) {}
    },
    uploadCancel() {
      this.base64 = [];
      this.file_value = "";
    },
    removeItem(item, key) {
      this.$dialog
        .confirm("Вы точно хотите удалить?", {
          okText: "Удалить",
          cancelText: "Отмена",
        })
        .then(() => {
          this.$loading(true);
          this.$http
            .post(`${this.link}/${item.id}`, { _method: "DELETE" })
            .then((response) => {
              this.result.splice(key, 1);
            })
            .catch((error) => {})
            .finally(() => {
              setTimeout(() => {
                this.$loading(false);
              }, 400);
            });
        })
        .catch(() => {});
    },
    removeItemBase64(key) {
      this.base64.splice(key, 1);
      this.$emit("input", this.base64);
    },
    positionItem() {},
  },
  computed: {
    countNewImages: {
      get() {
        return this.base64.length;
      },
    },
    result_length: function () {
      return this.result.length;
    },
  },
  watch: {
    countNewImages(val) {
      if (val > 0) {
        this.$modal.show("upload");
      } else {
        this.uploading = false;
        this.$modal.hide("upload");
      }
    },
    result_length() {
      this.base64 = [];
    },
  },
};
</script>
<style lang="scss">
.images {
  margin-bottom: 30px;
  background: #f2f2f2;
  padding: 15px;
  border-radius: 10px;
  .choose-file {
    position: absolute;
    opacity: 0;
  }

  ul.pimages {
    display: flex;
    flex-wrap: wrap;
    margin-right: -10px;
    & > li {
      background: rgba($color: #ffffff, $alpha: 0.9);
      max-width: 50%;
      width: 140px;
      height: 140px;
      padding: 10px;
      margin-right: 10px;
      border: 1px solid #ebebeb;
      position: relative;
      margin-bottom: 10px;
      border-radius: 10px;
      overflow: hidden;
      text-align: center;
      &.noload {
        border-color: red;
        border-width: 3px;
      }
      & > img {
        width: 100%;
        height: 100%;
        position: absolute;
        max-width: 75%;
        max-height: 75%;
        -o-object-fit: contain;
        object-fit: contain;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      & > button {
        border: none;
        box-shadow: none;
        position: absolute;
        right: 5px;
        top: 5px;
        background: #ebebeb;
        height: 20px;
        width: 20px;
        font-size: 10px;
        text-align: center;
        padding: 3px;
        border-radius: 3px;
      }
    }
  }

  .loading {
    opacity: 0.3;
    pointer-events: none;
    cursor: progress;
  }
}
</style>
